import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  fieldsContainer: {
    flex: 1,
    display: "inline-flex",
    justifyContent: "space-between",
    gap: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      display: "block",
      "& .flex-input": { width: "100%", marginBottom: theme.spacing(2) },
    },
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: theme.spacing(1),
    [theme.breakpoints.up("lg")]: {
      marginTop: 0,
      flex: "0 0 auto",
      alignSelf: "center",
    },
  },
}));
